var map = {
	"./day/logo.svg": 195,
	"./day/marker.svg": 196,
	"./day/marker_active.svg": 197,
	"./day/position.svg": 198,
	"./gps.svg": 199,
	"./headphones.svg": 200,
	"./logo_coop.svg": 201,
	"./night/logo.svg": 202,
	"./night/marker.svg": 203,
	"./night/marker_active.svg": 204,
	"./night/position.svg": 205,
	"./phone.svg": 206,
	"./texture.svg": 207
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;